(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["boutique-split-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var DAY_INDEX = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };

    function parseHours(value) {
      var ranges = [];
      if (!value) return ranges;
      var pattern = /(\d{1,2})\s*[h:.]\s*(\d{2})?\s*\D*?(\d{1,2})\s*[h:.]\s*(\d{2})?/g;
      var match;
      while ((match = pattern.exec(value)) !== null) {
        var open = parseInt(match[1], 10) * 60 + (match[2] ? parseInt(match[2], 10) : 0);
        var close = parseInt(match[3], 10) * 60 + (match[4] ? parseInt(match[4], 10) : 0);
        if (close > open) ranges.push({ open: open, close: close });
      }
      ranges.sort(function (a, b) {
        return a.open - b.open;
      });
      return ranges;
    }

    function getParisNow() {
      try {
        var parts = new Intl.DateTimeFormat('en-US', {
          timeZone: 'Europe/Paris',
          weekday: 'short',
          hour: 'numeric',
          minute: 'numeric',
          hour12: false,
        }).formatToParts(new Date());
        var values = {};
        parts.forEach(function (part) {
          values[part.type] = part.value;
        });
        return {
          day: DAY_INDEX[values.weekday],
          minutes: ((parseInt(values.hour, 10) % 24) * 60) + parseInt(values.minute, 10),
        };
      } catch (error) {
        var now = new Date();
        return { day: now.getDay(), minutes: now.getHours() * 60 + now.getMinutes() };
      }
    }

    function formatTime(minutes) {
      var hours = Math.floor(minutes / 60);
      var mins = minutes % 60;
      if (mins === 0) return hours + 'h';
      return hours + 'h' + (mins < 10 ? '0' + mins : mins);
    }

    function initHours(container) {
      var statusEl = container.querySelector('[data-boutique-hours-status]');
      var statusText = container.querySelector('[data-boutique-hours-status-text]');
      var rows = {};
      container.querySelectorAll('[data-day]').forEach(function (row) {
        rows[row.dataset.day] = row;
      });

      var now = getParisNow();
      var todayRow = rows[String(now.day)];
      if (todayRow) todayRow.classList.add('is-today');
      if (!statusEl || !statusText) return;

      var todayRanges = todayRow ? parseHours(todayRow.dataset.hours) : [];
      var currentRange = null;
      for (var i = 0; i < todayRanges.length; i++) {
        if (now.minutes >= todayRanges[i].open && now.minutes < todayRanges[i].close) {
          currentRange = todayRanges[i];
          break;
        }
      }
      var text;

      if (currentRange) {
        text = container.dataset.textOpen + ' · ' + container.dataset.textClosesAt.replace('{time}', formatTime(currentRange.close));
        statusEl.classList.add('is-open');
        if (todayRow) todayRow.classList.add('is-open');
      } else {
        statusEl.classList.add('is-closed');
        text = container.dataset.textClosed;
        for (var offset = 0; offset < 7; offset++) {
          var day = (now.day + offset) % 7;
          var row = rows[String(day)];
          if (!row) continue;
          var ranges = parseHours(row.dataset.hours);
          var next = null;
          for (var j = 0; j < ranges.length; j++) {
            if (offset > 0 || ranges[j].open > now.minutes) {
              next = ranges[j];
              break;
            }
          }
          if (!next) continue;
          var time = formatTime(next.open);
          if (offset === 0) {
            text += ' · ' + container.dataset.textOpensAt.replace('{time}', time);
          } else {
            var dayName = row.querySelector('.boutique-hours__day-name');
            text += ' · ' + container.dataset.textOpensOn
              .replace('{day}', dayName ? dayName.textContent.trim().toLowerCase() : '')
              .replace('{time}', time);
          }
          break;
        }
      }

      statusText.textContent = text;
      statusEl.hidden = false;
    }

    function initAll(root) {
      (root || document).querySelectorAll('[data-boutique-hours]').forEach(initHours);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boutiques-carousel"] && !Shopify.designMode) return;
  try {
    
  class BoutiquesCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.controls = this.querySelector('[data-carousel-controls]');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      this.hideControlsWhenDisabled = this.dataset.hideControlsWhenDisabled === 'true';
      if (!this.track) return;

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByPage(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByPage(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows());
      this.updateArrows();
    }

    scrollByPage(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.prevButton || !this.nextButton) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.prevButton.disabled = this.track.scrollLeft <= 4;
      this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 4;

      if (this.controls && this.hideControlsWhenDisabled) {
        this.controls.hidden = this.prevButton.disabled && this.nextButton.disabled;
      }
    }
  }

  if (!customElements.get('boutiques-carousel')) {
    customElements.define('boutiques-carousel', BoutiquesCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["event-product-carousel"] && !Shopify.designMode) return;
  try {
    
  class EventProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      if (!this.track) return;

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByPage(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByPage(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows());
      this.updateArrows();
    }

    scrollByPage(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.prevButton || !this.nextButton) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.classList.toggle('is-scrollable', maxScroll > 4);
      this.prevButton.disabled = this.track.scrollLeft <= 4;
      this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 4;
    }
  }

  if (!customElements.get('event-product-carousel')) {
    customElements.define('event-product-carousel', EventProductCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  // Remembers the mute preference across page reloads, shared with every other video on the
  // site (e.g. recipe hero videos) so muting/unmuting one carries over to the others.
  const MUTE_STORAGE_KEY = 'site-video-muted';

  const getStoredMutePreference = () => {
    try {
      return localStorage.getItem(MUTE_STORAGE_KEY);
    } catch (err) {
      return null;
    }
  };

  const setStoredMutePreference = (muted) => {
    try {
      localStorage.setItem(MUTE_STORAGE_KEY, muted ? 'true' : 'false');
    } catch (err) {
      // localStorage unavailable (private browsing, storage full, etc.) — ignore.
    }
  };

  class HomeHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.home-hero__slide'));
      this.dots = Array.from(this.querySelectorAll('[data-slider-dot]'));
      this.soundButton = this.querySelector('[data-sound-toggle]');
      this.current = 0;
      this.autoplaySpeed = parseInt(this.dataset.autoplay, 10) || 0;

      const storedMutePreference = getStoredMutePreference();
      this.soundMuted = storedMutePreference !== null ? storedMutePreference === 'true' : true;

      if (this.slides.length < 2) return;

      const prev = this.querySelector('[data-slider-prev]');
      const next = this.querySelector('[data-slider-next]');
      if (prev) prev.addEventListener('click', () => this.goTo(this.current - 1));
      if (next) next.addEventListener('click', () => this.goTo(this.current + 1));
      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(parseInt(dot.dataset.sliderDot, 10)));
      });

      if (this.soundButton) {
        this.soundButton.addEventListener('click', () => this.toggleSound());
        this.updateSoundButton();
      }

      // a video slide advances when its video ends, instead of the autoplay timer
      this.slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        if (video) {
          video.removeAttribute('loop');
          video.muted = this.soundMuted;
          video.addEventListener('ended', () => {
            if (i === this.current) this.goTo(this.current + 1);
          });
        }
      });

      this.scheduleNext();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    goTo(index) {
      const count = this.slides.length;
      this.current = ((index % count) + count) % count;

      this.slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === this.current);
        const video = slide.querySelector('video');
        if (video && i !== this.current) video.pause();
      });
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === this.current));

      this.scheduleNext();
    }

    scheduleNext() {
      this.stopAutoplay();

      const video = this.slides[this.current].querySelector('video');
      if (video) {
        video.currentTime = 0;
        video.muted = this.soundMuted;
        video.play().catch(() => {
          // Browsers block unmuted autoplay without a prior user gesture on the page. Force mute
          // so the slide still plays instead of freezing, and sync the UI/preference to match.
          if (!video.muted) {
            video.muted = true;
            this.soundMuted = true;
            setStoredMutePreference(true);
            this.updateSoundButton();
            video.play().catch(() => this.startAutoplay());
          } else {
            this.startAutoplay();
          }
        });
      } else {
        this.startAutoplay();
      }
    }

    startAutoplay() {
      if (this.autoplaySpeed > 0) {
        this.timer = setInterval(() => this.goTo(this.current + 1), this.autoplaySpeed * 1000);
      }
    }

    stopAutoplay() {
      if (this.timer) clearInterval(this.timer);
    }

    toggleSound() {
      this.soundMuted = !this.soundMuted;
      setStoredMutePreference(this.soundMuted);
      const video = this.slides[this.current].querySelector('video');
      if (video) video.muted = this.soundMuted;
      this.updateSoundButton();
    }

    updateSoundButton() {
      if (this.soundButton) {
        this.soundButton.setAttribute('aria-pressed', !this.soundMuted);
        this.soundButton.setAttribute('aria-label', this.soundMuted ? 'Activer le son' : 'Désactiver le son');
      }
    }
  }

  if (!customElements.get('home-hero-slider')) {
    customElements.define('home-hero-slider', HomeHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-product-carousel"] && !Shopify.designMode) return;
  try {
    
  class HomeProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      if (!this.track) return;

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByPage(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByPage(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows());
      this.updateArrows();
    }

    scrollByPage(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.prevButton || !this.nextButton) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.prevButton.disabled = this.track.scrollLeft <= 4;
      this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 4;
    }
  }

  if (!customElements.get('home-product-carousel')) {
    customElements.define('home-product-carousel', HomeProductCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-recipe-carousel"] && !Shopify.designMode) return;
  try {
    
  class HomeRecipeCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      if (!this.track) return;

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByPage(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByPage(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows());
      this.updateArrows();
    }

    scrollByPage(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.prevButton || !this.nextButton) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.prevButton.disabled = this.track.scrollLeft <= 4;
      this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 4;
    }
  }

  if (!customElements.get('home-recipe-carousel')) {
    customElements.define('home-recipe-carousel', HomeRecipeCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
  constructor() {
  super();

  this.addEventListener('change', debounce((event) => {
  const body = JSON.stringify({ note: event.target.value });
  fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
  }, 300))
  }
  }

  customElements.define('cart-note', CartNote);

  class CartDeliveryEstimator extends HTMLElement {
  constructor() {
  super();
  this.elCountry = this.querySelector('.js-estimator-country');
  this.elPostalWrapper = this.querySelector('.js-estimator-postal-wrapper');
  this.elPostal = this.querySelector('.js-estimator-postal');
  this.elInternational = this.querySelector('.js-estimator-international');
  this.elFrance = this.querySelector('.js-estimator-france');
  this.elParis = this.querySelector('.js-estimator-paris');
  // Postal codes outside Paris eligible for courier delivery
  // (shop metafield custom.courier_postal_codes)
  this.courierZips = (this.dataset.courierZips || '')
  .split(',')
  .map((zip) => zip.trim())
  .filter((zip) => zip.length);

  if (!this.elCountry || !this.elPostal) return;

  this.elCountryList = this.querySelector('.js-estimator-country-list');
  // label = translated name displayed by Shopify, value = canonical English name.
  // Deduplicated by label: the tag can output the same country several times.
  const seenLabels = [];
  this.countryOptions = Array.from(this.querySelectorAll('#CartEstimatorCountryList option'))
  .map((option) => {
  const value = option.value.trim();
  const label = (option.textContent || option.value).trim();
  return { value: value, label: label };
  })
  .filter((option) => {
  if (!option.label.length) return false;
  if (option.label.indexOf('---') !== -1) return false;
  const key = this.normalize(option.label);
  if (seenLabels.indexOf(key) !== -1) return false;
  seenLabels.push(key);
  return true;
  });
  this.activeIndex = -1;

  this.elCountry.addEventListener('input', () => {
  this.update(true);
  this.renderSuggestions();
  });
  this.elCountry.addEventListener('focus', () => this.renderSuggestions());
  this.elCountry.addEventListener('blur', () => this.closeSuggestions());
  this.elCountry.addEventListener('keydown', (event) => this.onCountryKeydown(event));
  this.elPostal.addEventListener('input', () => {
  // Digits only
  const digits = this.elPostal.value.replace(/\D/g, '');
  if (digits !== this.elPostal.value) this.elPostal.value = digits;
  this.update(true);
  });
  this.restore();
  }

  normalize(value) {
  return value.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  renderSuggestions() {
  const query = this.normalize(this.elCountry.value);
  if (!query) {
  this.closeSuggestions();
  return;
  }

  const matches = this.countryOptions.filter((country) => this.normalize(country.label).indexOf(query) !== -1);
  const isExactMatch = matches.length === 1 && this.normalize(matches[0].label) === query;
  if (!matches.length || isExactMatch) {
  this.closeSuggestions();
  return;
  }

  this.activeIndex = -1;
  this.elCountryList.innerHTML = '';
  matches.forEach((country) => {
  const item = document.createElement('li');
  item.setAttribute('role', 'option');
  item.textContent = country.label;
  item.addEventListener('mousedown', (event) => {
  event.preventDefault();
  this.selectCountry(country.label);
  });
  this.elCountryList.appendChild(item);
  });
  this.elCountryList.hidden = false;
  this.elCountry.setAttribute('aria-expanded', 'true');
  }

  selectCountry(label) {
  this.elCountry.value = label;
  this.closeSuggestions();
  this.update(true);
  }

  closeSuggestions() {
  this.elCountryList.hidden = true;
  this.elCountry.setAttribute('aria-expanded', 'false');
  this.activeIndex = -1;
  }

  onCountryKeydown(event) {
  if (this.elCountryList.hidden) return;
  const items = Array.from(this.elCountryList.children);

  if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
  event.preventDefault();
  const delta = event.key === 'ArrowDown' ? 1 : -1;
  this.activeIndex = (this.activeIndex + delta + items.length) % items.length;
  items.forEach((item, index) => item.classList.toggle('is-active', index === this.activeIndex));
  items[this.activeIndex].scrollIntoView({ block: 'nearest' });
  } else if (event.key === 'Enter') {
  if (this.activeIndex > -1 && items[this.activeIndex]) {
  event.preventDefault();
  this.selectCountry(items[this.activeIndex].textContent);
  }
  } else if (event.key === 'Escape') {
  this.closeSuggestions();
  }
  }

  restore() {
  let saved = {};
  try {
  saved = JSON.parse(sessionStorage.getItem('cart-delivery-estimator')) || {};
  } catch (e) {}
  if (saved.country) {
  this.elCountry.value = saved.country;
  } else if (this.dataset.customerCountry) {
  // Logged-in customer: prefill from the default address. The address
  // stores the canonical English name; display the translated label
  const cleaned = this.normalize(this.dataset.customerCountry);
  const matched = this.countryOptions.find((option) => {
  return this.normalize(option.value) === cleaned || this.normalize(option.label) === cleaned;
  });
  this.elCountry.value = matched ? matched.label : this.dataset.customerCountry;
  }
  if (saved.postal) {
  this.elPostal.value = saved.postal;
  } else if (this.dataset.customerZip) {
  this.elPostal.value = this.dataset.customerZip.replace(/\D/g, '');
  }
  this.update(false);
  }

  update(save) {
  const country = this.elCountry.value;
  const postal = this.elPostal.value;

  if (save) {
  try {
  sessionStorage.setItem('cart-delivery-estimator', JSON.stringify({ country: country, postal: postal }));
  } catch (e) {}
  }

  const cleanedCountry = this.normalize(country);
  const cleanedPostal = postal.trim();
  // Match the typed text against translated labels (and canonical values as
  // a fallback) to resolve the canonical English country name
  const matched = this.countryOptions.find((option) => {
  return this.normalize(option.label) === cleanedCountry || this.normalize(option.value) === cleanedCountry;
  });
  const isKnownCountry = !!matched;
  const isFrance = isKnownCountry && matched.value === 'France';
  // French postal code: 5 digits, department 01-98
  const isValidPostal = /^(0[1-9]|[1-8][0-9]|9[0-8])[0-9]{3}$/.test(cleanedPostal);
  // Paris intra-muros, or a bordering commune eligible for courier delivery
  const isParisPostal = /^75\d{3}$/.test(cleanedPostal) || this.courierZips.indexOf(cleanedPostal) !== -1;

  // Red state once the 5 digits are typed but don't form a valid FR postal code
  this.elPostal.classList.toggle('is-invalid', cleanedPostal.length === 5 && !isValidPostal);

  this.elPostalWrapper.hidden = !isFrance;
  this.elInternational.hidden = !isKnownCountry || isFrance;
  this.elFrance.hidden = !isFrance || !isValidPostal || isParisPostal;
  this.elParis.hidden = !isFrance || !isParisPostal;
  }
  }

  customElements.define('cart-delivery-estimator', CartDeliveryEstimator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mini-cart"]) return;
  try {
    
  class ProductRecommendationsMinicart extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations-mini-cart');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 0px 0px' }).observe(this);
    }
  }
  customElements.define('product-recommendations-mini-cart', ProductRecommendationsMinicart);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.js-quick-add');
    if (!button || button.classList.contains('is-loading')) return;

    const cartItems = button.closest('cart-items') || document.querySelector('cart-items');
    if (!cartItems) return;

    const spinner = cartItems.querySelector('#mini-cart-footer .loading-overlay__spinner');
    button.classList.add('is-loading');
    if (spinner) spinner.classList.remove('hidden');

    const body = JSON.stringify({
      items: [{ id: Number(button.dataset.variantId), quantity: 1 }],
      sections: cartItems.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(routes.cart_add_url, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((response) => {
        if (response.status && response.status !== 200) return;
        document.dispatchEvent(new CustomEvent('product:added'));
        cartItems.renderContents(response);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        button.classList.remove('is-loading');
        if (spinner) spinner.classList.add('hidden');
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pro-product-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProProductCarousel extends HTMLElement {
    connectedCallback() {
      const section = this.closest('.pro-product-carousel');
      this.track = this.querySelector('[data-carousel-track]');
      this.prevButton = section ? section.querySelector('[data-carousel-prev]') : null;
      this.nextButton = section ? section.querySelector('[data-carousel-next]') : null;
      if (!this.track) return;

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByAmount(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByAmount(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows());
      this.updateArrows();
    }

    scrollByAmount(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth * 0.6, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.prevButton || !this.nextButton) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.prevButton.disabled = this.track.scrollLeft <= 4;
      this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 4;
    }
  }

  if (!customElements.get('pro-product-carousel')) {
    customElements.define('pro-product-carousel', ProProductCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProductCollectionCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      if (!this.track) return;

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByPage(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByPage(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows());
      this.updateArrows();
    }

    scrollByPage(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.prevButton || !this.nextButton) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.prevButton.disabled = this.track.scrollLeft <= 4;
      this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 4;
    }
  }

  if (!customElements.get('product-collection-carousel')) {
    customElements.define('product-collection-carousel', ProductCollectionCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recipe-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProductRecipeCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.controls = this.querySelector('[data-carousel-controls]');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      this.hideControlsWhenDisabled = this.dataset.hideControlsWhenDisabled === 'true';
      if (!this.track) return;

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByPage(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByPage(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows());
      this.updateArrows();
    }

    scrollByPage(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.prevButton || !this.nextButton) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.prevButton.disabled = this.track.scrollLeft <= 4;
      this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 4;

      if (this.controls && this.hideControlsWhenDisabled) {
        this.controls.hidden = this.prevButton.disabled && this.nextButton.disabled;
      }
    }
  }

  if (!customElements.get('product-recipe-carousel')) {
    customElements.define('product-recipe-carousel', ProductRecipeCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-similar-carousel"] && !Shopify.designMode) return;
  try {
    
  class ProductSimilarCarousel extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('[data-carousel-track]')) {
        this.initCarousel();
      } else {
        this.loadRecommendations();
      }
    }

    loadRecommendations() {
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-similar-carousel');
          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            this.initCarousel();
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    initCarousel() {
      this.track = this.querySelector('[data-carousel-track]');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      if (!this.track) return;

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByPage(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByPage(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows());
      this.updateArrows();
    }

    scrollByPage(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.prevButton || !this.nextButton) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.prevButton.disabled = this.track.scrollLeft <= 4;
      this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 4;
    }
  }

  if (!customElements.get('product-similar-carousel')) {
    customElements.define('product-similar-carousel', ProductSimilarCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const hero = document.querySelector('[data-recipe-hero]');
    const videoElement = hero?.querySelector('[data-video-element]');
    const controls = hero?.querySelector('[data-video-controls]');

    if (!videoElement) return;

    const mediaEl = hero.querySelector('.recipe-hero__media');
    const videoContainer = hero?.querySelector('[data-video-container]');
    const expandHint = hero?.querySelector('[data-expand-hint]');
    const playOverlay = hero?.querySelector('[data-play-overlay]');
    const playTriangleIcon = playOverlay?.querySelector('.recipe-hero__icon-play');
    const pauseIcon = playOverlay?.querySelector('.recipe-hero__icon-pause');
    const progressInput = controls?.querySelector('[data-progress-input]');
    const progressFill = controls?.querySelector('[data-progress-fill]');
    const currentTimeEl = controls?.querySelector('[data-current-time]');
    const muteBtn = controls?.querySelector('[data-mute-btn]');
    const unmutedIcon = muteBtn?.querySelector('.recipe-hero__icon-unmuted');
    const mutedIcon = muteBtn?.querySelector('.recipe-hero__icon-muted');
    const sizeBtn = controls?.querySelector('[data-size-btn]');
    const sizeMenu = controls?.querySelector('[data-size-menu]');
    const sizeOptions = controls?.querySelectorAll('[data-size-option]');
    const mobileFullscreenBtn = controls?.querySelector('[data-mobile-fullscreen-btn]');
    const fsEnterIcon = mobileFullscreenBtn?.querySelector('.recipe-hero__icon-fs-enter');
    const fsExitIcon = mobileFullscreenBtn?.querySelector('.recipe-hero__icon-fs-exit');

    let currentSize = 'normal';
    // The hero's "normal" (aspect-ratio-bounded) height, captured right before ever leaving that
    // state — reused so "fullwidth" grows only the width and stays bordered by this height,
    // instead of stretching to 100vh on screens where the hero is naturally shorter than that.
    let naturalHeroHeight = null;
    // Remembers whichever size ("normal" or "fullwidth") was active right before entering
    // fullscreen, so exiting (Escape, browser UI, or the toggle button) restores that instead of
    // always snapping back to "normal".
    let sizeBeforeFullscreen = 'normal';

    const formatTime = (seconds) => {
      if (!seconds || isNaN(seconds)) return '0:00';
      const mins = Math.floor(seconds / 60);
      const secs = Math.floor(seconds % 60);
      return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };

    const updateSizeUI = () => {
      sizeOptions?.forEach(opt => {
        if (opt.dataset.sizeOption === currentSize) {
          opt.classList.add('active');
        } else {
          opt.classList.remove('active');
        }
      });
    };

    const isFullscreen = () =>
      !!(document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement);

    const requestFullscreen = (el) => {
      const request = el.requestFullscreen || el.webkitRequestFullscreen || el.mozRequestFullScreen || el.msRequestFullscreen;
      request?.call(el);
    };

    const exitFullscreen = () => {
      const exit = document.exitFullscreen || document.webkitExitFullscreen || document.mozCancelFullScreen || document.msExitFullscreen;
      exit?.call(document);
    };

    // Only "fullwidth" is a CSS-driven size (smoothly animated via the width transition on
    // .recipe-hero__media). "fullscreen" goes through the real browser Fullscreen API instead —
    // see handleFullscreenChange, which keeps `currentSize`/classes in sync with the actual state.
    const applySize = (size) => {
      if (currentSize === 'normal' && size !== 'normal') {
        naturalHeroHeight = hero.getBoundingClientRect().height;
      }

      if (size === 'fullwidth' && naturalHeroHeight != null) {
        hero.style.height = `${naturalHeroHeight}px`;
      } else if (size !== 'fullwidth') {
        hero.style.height = '';
      }

      hero.classList.toggle('recipe-hero--fullwidth', size === 'fullwidth');
      currentSize = size;
      updateSizeUI();
    };

    // Applies a size without animating the width transition — used when leaving real fullscreen,
    // since the browser itself exits instantly and a lingering 0.8s width animation would look laggy.
    const applySizeInstant = (size) => {
      if (mediaEl) mediaEl.style.transition = 'none';
      applySize(size);
      if (mediaEl) {
        void mediaEl.offsetHeight; // force reflow so the width change above is committed without transition
        requestAnimationFrame(() => {
          mediaEl.style.transition = '';
        });
      }
    };

    // The dropdown is the only way to resize the video — there is no automatic resizing on play/pause.
    const setSizeMode = (size) => {
      if (size === 'fullscreen') {
        if (currentSize !== 'fullscreen') sizeBeforeFullscreen = currentSize;
        requestFullscreen(hero);
      } else {
        if (isFullscreen()) exitFullscreen();
        applySize(size);
      }

      sizeMenu?.classList.remove('open');
      sizeBtn?.setAttribute('aria-expanded', 'false');
    };

    const handleFullscreenChange = () => {
      const fsActive = isFullscreen();
      hero.classList.toggle('recipe-hero--fullscreen', fsActive);

      if (fsEnterIcon) fsEnterIcon.style.display = fsActive ? 'none' : 'block';
      if (fsExitIcon) fsExitIcon.style.display = fsActive ? 'block' : 'none';
      mobileFullscreenBtn?.setAttribute('aria-label', fsActive ? 'Quitter le plein écran' : 'Plein écran');

      if (fsActive) {
        currentSize = 'fullscreen';
        updateSizeUI();
      } else if (currentSize === 'fullscreen') {
        // Exited via Escape, the browser's own fullscreen UI, or the toggle button — snap back
        // instantly (no width animation) to whichever size was active before entering fullscreen.
        applySizeInstant(sizeBeforeFullscreen);
      }
    };

    ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange'].forEach((evt) => {
      document.addEventListener(evt, handleFullscreenChange);
    });

    // Mobile: a single button toggles real fullscreen instead of the desktop size dropdown.
    if (mobileFullscreenBtn) {
      mobileFullscreenBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        if (isFullscreen()) {
          exitFullscreen();
        } else {
          if (currentSize !== 'fullscreen') sizeBeforeFullscreen = currentSize;
          requestFullscreen(hero);
        }
      });
    }

    const togglePlay = () => {
      if (videoElement.paused) {
        videoElement.play();
      } else {
        videoElement.pause();
      }
    };

    const updatePlayIcon = () => {
      if (playTriangleIcon) playTriangleIcon.style.display = videoElement.paused ? 'block' : 'none';
      if (pauseIcon) pauseIcon.style.display = videoElement.paused ? 'none' : 'block';
    };

    // Play/pause circle follows the mouse cursor (desktop only — touch devices keep it centered via CSS)
    const hasHoverCursor = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    const handleMouseMove = (e) => {
      const rect = videoContainer.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      playOverlay.style.left = `${x}px`;
      playOverlay.style.top = `${y}px`;
      playOverlay.classList.toggle('is-hidden', !!e.target.closest('[data-video-controls]') || !!e.target.closest('[data-expand-hint]'));
    };

    const handleMouseDown = () => playOverlay?.classList.add('is-clicking');
    const handleMouseUp = () => playOverlay?.classList.remove('is-clicking');
    const handleMouseLeave = () => playOverlay?.classList.remove('is-clicking');

    if (videoContainer && playOverlay && hasHoverCursor) {
      videoContainer.addEventListener('mousemove', handleMouseMove);
      videoContainer.addEventListener('mousedown', handleMouseDown);
      videoContainer.addEventListener('mouseup', handleMouseUp);
      videoContainer.addEventListener('mouseleave', handleMouseLeave);
    }

    const updateProgress = () => {
      const percent = (videoElement.currentTime / videoElement.duration) * 100 || 0;
      progressFill.style.width = `${percent}%`;
      progressInput.value = percent;
      currentTimeEl.textContent = formatTime(videoElement.currentTime);
    };

    const handleProgressChange = (e) => {
      const percent = parseFloat(e.target.value);
      videoElement.currentTime = (percent / 100) * videoElement.duration;
    };

    const updateMuteIcon = () => {
      if (unmutedIcon) unmutedIcon.style.display = videoElement.muted ? 'none' : 'block';
      if (mutedIcon) mutedIcon.style.display = videoElement.muted ? 'block' : 'none';
    };

    // Remembers the mute preference across page reloads, shared with every other video on the
    // site (e.g. the homepage hero) so muting/unmuting one carries over to the others.
    const MUTE_STORAGE_KEY = 'site-video-muted';

    const getStoredMutePreference = () => {
      try {
        return localStorage.getItem(MUTE_STORAGE_KEY);
      } catch (err) {
        return null;
      }
    };

    const setStoredMutePreference = (muted) => {
      try {
        localStorage.setItem(MUTE_STORAGE_KEY, muted ? 'true' : 'false');
      } catch (err) {
        // localStorage unavailable (private browsing, storage full, etc.) — ignore.
      }
    };

    const toggleMute = () => {
      videoElement.muted = !videoElement.muted;
      setStoredMutePreference(videoElement.muted);
      updateMuteIcon();
    };

    // Click on video to play/pause (ignore clicks on the controls bar)
    if (videoContainer) {
      videoContainer.addEventListener('click', (e) => {
        if (e.target.closest('[data-video-controls]')) return;
        togglePlay();
      });
    }

    // Progress bar
    if (progressInput) progressInput.addEventListener('input', handleProgressChange);

    // Volume max by default; mute/unmute toggle only, restoring the last saved preference
    videoElement.volume = 1;
    const storedMutePreference = getStoredMutePreference();
    if (storedMutePreference !== null) {
      videoElement.muted = storedMutePreference === 'true';
    }
    if (muteBtn) {
      muteBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        toggleMute();
      });
      updateMuteIcon();
    }

    // Size menu
    if (sizeBtn) {
      sizeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        const isOpen = sizeMenu?.classList.toggle('open');
        sizeBtn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    sizeOptions?.forEach(option => {
      option.addEventListener('click', () => {
        setSizeMode(option.dataset.sizeOption);
      });
    });

    // Nudge button shown next to the video while in "normal" (left) position — a shortcut for
    // the "Pleine largeur" dropdown option.
    if (expandHint) {
      expandHint.addEventListener('click', (e) => {
        e.stopPropagation();
        const stillOnPoster = videoElement.paused && videoElement.currentTime === 0;
        setSizeMode('fullwidth');

        // Still showing the poster (never played)? Wait for the widen animation to fully finish
        // before starting playback, so the poster gives way to the video only once the media
        // area has settled into its full width — not mid-transition.
        if (stillOnPoster && mediaEl) {
          let started = false;
          const startPlayback = () => {
            if (started) return;
            started = true;
            videoElement.play();
          };
          const handleTransitionEnd = (ev) => {
            if (ev.target !== mediaEl || ev.propertyName !== 'width') return;
            mediaEl.removeEventListener('transitionend', handleTransitionEnd);
            startPlayback();
          };
          mediaEl.addEventListener('transitionend', handleTransitionEnd);
          // Safety fallback in case transitionend doesn't fire (matches the 0.8s CSS transition).
          setTimeout(startPlayback, 900);
        }
      });
    }

    // Close dropdown on click outside
    document.addEventListener('click', (e) => {
      if (!sizeMenu?.contains(e.target) && !sizeBtn?.contains(e.target)) {
        sizeMenu?.classList.remove('open');
        sizeBtn?.setAttribute('aria-expanded', 'false');
      }
    });

    // Video events
    videoElement.addEventListener('play', updatePlayIcon);
    videoElement.addEventListener('pause', updatePlayIcon);
    videoElement.addEventListener('ended', updatePlayIcon);

    // The poster is only ever replaced once playback actually starts rendering frames — that's
    // also the cue to start allowing the controls bar to show on hover (never before).
    videoElement.addEventListener('playing', () => {
      videoContainer?.classList.add('has-played');
    }, { once: true });

    videoElement.addEventListener('timeupdate', updateProgress);

    videoElement.addEventListener('loadedmetadata', () => {
      updateSizeUI();
      updatePlayIcon();
    });

    // Escape exits "fullwidth" mode; real fullscreen already handles Escape natively
    // and is caught by handleFullscreenChange above.
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && currentSize === 'fullwidth') {
        applySize('normal');
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-list-hero"] && !Shopify.designMode) return;
  try {
    
  class RecipeSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-recipe-search-input]');
      if (!this.input) return;
      this.input.addEventListener('input', () => this.filter());
    }

    filter() {
      const query = this.input.value.trim().toLowerCase();
      const cards = document.querySelectorAll('[data-recipe-card]');
      let visibleCount = 0;

      cards.forEach((card) => {
        const name = (card.getAttribute('data-recipe-name') || '').toLowerCase();
        const matches = query === '' || name.includes(query);
        card.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      const emptyState = document.querySelector('[data-recipe-list-empty]');
      if (emptyState) emptyState.hidden = visibleCount !== 0;
    }
  }

  if (!customElements.get('recipe-search')) {
    customElements.define('recipe-search', RecipeSearch);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-related-products"] && !Shopify.designMode) return;
  try {
    
  class RecipeProductCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-carousel-track]');
      this.prevButton = this.querySelector('[data-carousel-prev]');
      this.nextButton = this.querySelector('[data-carousel-next]');
      if (!this.track) return;

      if (this.prevButton) this.prevButton.addEventListener('click', () => this.scrollByPage(-1));
      if (this.nextButton) this.nextButton.addEventListener('click', () => this.scrollByPage(1));
      this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
      window.addEventListener('resize', () => this.updateArrows());
      this.updateArrows();
    }

    scrollByPage(direction) {
      this.track.scrollBy({ left: direction * this.track.clientWidth, behavior: 'smooth' });
    }

    updateArrows() {
      if (!this.prevButton || !this.nextButton) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      this.prevButton.disabled = this.track.scrollLeft <= 4;
      this.nextButton.disabled = this.track.scrollLeft >= maxScroll - 4;
    }
  }

  if (!customElements.get('recipe-product-carousel')) {
    customElements.define('recipe-product-carousel', RecipeProductCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-steps"] && !Shopify.designMode) return;
  try {
    
  class RecipeStepsInfo extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      if (!this.details || !this.summary) return;
      this.desktopQuery = window.matchMedia('(min-width: 990px)');

      // Markup defaults to open (correct no-JS fallback); close it on
      // mobile/tablet once JS confirms the viewport.
      if (!this.desktopQuery.matches) this.details.removeAttribute('open');

      this.summary.addEventListener('click', (event) => this.handleClick(event));
    }

    handleClick(event) {
      // Locked open on desktop: block the native <details> toggle entirely.
      if (this.desktopQuery.matches) event.preventDefault();
    }
  }

  if (!customElements.get('recipe-steps-info')) {
    customElements.define('recipe-steps-info', RecipeStepsInfo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["store-locator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('store-locator-section')) {
    customElements.define(
      'store-locator-section',
      class StoreLocatorSection extends HTMLElement {
        connectedCallback() {
          if (this._initialized) return;
          this._initialized = true;
          this.mapElement = this.querySelector('[data-store-locator-map]');
          this.items = Array.from(this.querySelectorAll('[data-store-locator-item]'));
          this.filters = Array.from(this.querySelectorAll('[data-store-locator-filter]'));
          this.countElement = this.querySelector('[data-store-locator-count]');
          this.apiKey = this.dataset.apiKey || '';
          this.defaultLatitude = parseFloat(this.dataset.defaultLatitude || '');
          this.defaultLongitude = parseFloat(this.dataset.defaultLongitude || '');
          this.initialZoom = parseInt(this.dataset.initialZoom || '11', 10);
          this.accentColor = this.dataset.accentColor || '#d8232a';
          this.directionsLabel = this.dataset.directionsLabel || '';
          this.detailsLabel = this.dataset.detailsLabel || '';
          this.countLabelSingular = this.dataset.countLabelSingular || '';
          this.countLabelPlural = this.dataset.countLabelPlural || '';
          this.closeLabel = this.dataset.closeLabel || 'Close';
          this.mapFallback = this.dataset.mapFallback || '';
          this.enableClustering = this.dataset.enableClustering !== 'false';
          this.markerIconType = this.dataset.markerIconType || 'classic';
          this.activeIndex = -1;
          this.map = null;
          this.infoWindow = null;
          this.markers = [];
          this.clusterer = null;
          this.ready = false;
          this.activeFilter = 'all';

          this.setupListInteractions();
          this.setupFilterInteractions();
          this.applyFilter(this.activeFilter, false);

          if (this.mapElement && this.apiKey) {
            this.loadMap();
          }
        }

        setupListInteractions() {
          this.items.forEach((item, index) => {
            item.addEventListener('click', (event) => {
              if (event.target.closest('a')) return;
              this.activateStore(index, true, false);
            });

            item.addEventListener('keydown', (event) => {
              if (event.key !== 'Enter' && event.key !== ' ') return;
              if (event.target.closest('a')) return;
              event.preventDefault();
              this.activateStore(index, true, false);
            });
          });
        }

        setupFilterInteractions() {
          this.filters.forEach((filter) => {
            filter.addEventListener('click', () => {
              this.applyFilter(filter.dataset.cityFilter || 'all', true);
            });
          });
        }

        applyFilter(filterValue, moveMap) {
          this.activeFilter = filterValue || 'all';
          let visibleCount = 0;

          this.filters.forEach((filter) => {
            const isActive = (filter.dataset.cityFilter || 'all') === this.activeFilter;
            filter.classList.toggle('is-active', isActive);
            filter.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });

          this.items.forEach((item, index) => {
            const cityKey = item.dataset.cityKey || '';
            const isVisible = this.activeFilter === 'all' || cityKey === this.activeFilter;
            item.hidden = !isVisible;
            item.classList.toggle('is-hidden-by-filter', !isVisible);

            if (this.markers[index]) {
              this.markers[index].setVisible(isVisible);
            }

            if (isVisible) {
              visibleCount += 1;
            } else {
              item.classList.remove('is-active');
              item.removeAttribute('aria-current');
            }
          });

          if (this.countElement) {
            this.countElement.textContent = `${visibleCount} ${
              visibleCount === 1 ? this.countLabelSingular : this.countLabelPlural
            }`;
          }

          if (this.map) {
            this.fitMapToVisibleStores();
          }

          const activeItem = this.items[this.activeIndex];
          if (!activeItem || activeItem.hidden) {
            this.clearActiveStore();
          }
        }

        clearActiveStore() {
          this.activeIndex = -1;
          this.items.forEach((item) => {
            item.classList.remove('is-active');
            item.removeAttribute('aria-current');
          });

          if (this.infoWindow) {
            this.infoWindow.close();
          }
        }

        activateStore(index, focusMap, scrollList = true) {
          const item = this.items[index];
          if (!item) return;

          const isSameActiveStore = this.activeIndex === index;
          this.activeIndex = index;

          this.items.forEach((item, itemIndex) => {
            const isActive = itemIndex === index;
            item.classList.toggle('is-active', isActive);
            if (isActive) {
              item.setAttribute('aria-current', 'true');
            } else {
              item.removeAttribute('aria-current');
            }
          });

          if (focusMap && this.map && this.markers[index]) {
            const marker = this.markers[index];
            const position = marker.getPosition();
            if (position) {
              if (this.map.getZoom() < Math.max(this.initialZoom, 14)) {
                this.map.setZoom(Math.max(this.initialZoom, 14));
              }

              const projection = this.map.getProjection();
              if (projection) {
                const scale = Math.pow(2, this.map.getZoom());
                const isMobile = window.innerWidth < 750;
                const offset = isMobile ? 180 : 120;
                const markerPoint = projection.fromLatLngToPoint(position);
                const offsetCenter = projection.fromPointToLatLng(
                  new google.maps.Point(markerPoint.x, markerPoint.y - offset / scale)
                );
                this.map.panTo(offsetCenter);
              } else {
                this.map.panTo(position);
              }
            }
            this.openInfoWindow(item, marker);

            if (window.innerWidth < 750) {
              this.scrollMapIntoView();
            }
          } else if (isSameActiveStore && scrollList) {
            this.scrollItemInList(item);
            return;
          }

          if (scrollList) {
            this.scrollItemInList(item);
          }
        }

        scrollItemInList(item) {
          const list = this.querySelector('.store-locator__list');
          if (!list || !item) return;

          const itemTop = item.offsetTop;
          const targetTop = itemTop - (list.clientHeight - item.clientHeight) / 2;
          list.scrollTo({
            top: Math.max(targetTop, 0),
            behavior: 'smooth',
          });
        }

        scrollMapIntoView() {
          const mapColumn = this.querySelector('.store-locator__map-column');
          if (mapColumn) {
            mapColumn.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }

        openInfoWindow(item, marker) {
          if (!this.infoWindow || !marker) return;

          const name = item.dataset.name || '';
          const displayAddress = item.dataset.displayAddress || item.dataset.streetAddress || '';
          const country = item.dataset.country || '';
          const imageUrl = item.dataset.imageUrl || '';
          const directionsUrl = item.dataset.directionsUrl || '';
          const detailsUrl = item.dataset.detailsUrl || '';
          const phone = item.dataset.phone || '';
          const phoneDisplay = item.dataset.phoneDisplay || phone;

          const wrapper = document.createElement('div');
          wrapper.className = 'store-locator-info-window';

          const closeButton = document.createElement('button');
          closeButton.type = 'button';
          closeButton.className = 'store-locator-info-window__close';
          closeButton.setAttribute('aria-label', this.closeLabel);
          closeButton.textContent = '×';
          closeButton.addEventListener('click', (event) => {
            event.stopPropagation();
            this.infoWindow.close();
          });
          wrapper.appendChild(closeButton);

          if (imageUrl) {
            const image = document.createElement('img');
            image.className = 'store-locator-info-window__image';
            image.src = imageUrl;
            image.alt = name;
            image.loading = 'lazy';
            wrapper.appendChild(image);
          } else {
            const placeholder = document.createElement('div');
            placeholder.className = 'store-locator-info-window__image store-locator-info-window__image--placeholder';
            placeholder.innerHTML = `
              <svg viewBox="0 0 96 96" aria-hidden="true" focusable="false">
                <rect x="16" y="38" width="64" height="38" rx="3" fill="currentColor" opacity="0.14"></rect>
                <path d="M20 40 48 18l28 22" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round"></path>
                <path d="M32 76V52h32v24" fill="none" stroke="currentColor" stroke-width="4" stroke-linejoin="round"></path>
                <path d="M39 64c5-9 13-9 18 0-3 4-15 4-18 0Z" fill="currentColor"></path>
              </svg>
            `;
            wrapper.appendChild(placeholder);
          }

          const title = document.createElement('div');
          title.className = 'store-locator-info-window__title';
          title.textContent = name;
          wrapper.appendChild(title);

          const addressLines = [];
          if (displayAddress) {
            addressLines.push(displayAddress);
          } else if (country) {
            addressLines.push(country);
          }

          if (addressLines.length) {
            const addressLink = document.createElement(directionsUrl ? 'a' : 'div');
            addressLink.className = 'store-locator-info-window__row';
            if (directionsUrl) {
              addressLink.href = directionsUrl;
              addressLink.target = '_blank';
              addressLink.rel = 'noopener noreferrer';
            }
            addressLink.appendChild(this.createInfoIcon('marker'));

            const addressText = document.createElement('span');
            addressText.className = 'store-locator-info-window__address';

            addressLines.forEach((line, lineIndex) => {
              const addressLine = document.createElement('span');
              addressLine.className = 'store-locator-info-window__address-line';
              addressLine.textContent = line;
              addressText.appendChild(addressLine);
            });

            addressLink.appendChild(addressText);
            wrapper.appendChild(addressLink);
          }

          if (phone) {
            const phoneLink = document.createElement('a');
            phoneLink.className = 'store-locator-info-window__row';
            phoneLink.href = `tel:${phone.replace(/\s+/g, '')}`;
            phoneLink.appendChild(this.createInfoIcon('phone'));

            const phoneText = document.createElement('span');
            phoneText.textContent = phoneDisplay;
            phoneLink.appendChild(phoneText);
            wrapper.appendChild(phoneLink);
          }

          const links = document.createElement('div');
          links.className = 'store-locator-info-window__links';

          if (directionsUrl) {
            const directionsLink = document.createElement('a');
            directionsLink.className = 'store-locator-info-window__link';
            directionsLink.href = directionsUrl;
            directionsLink.target = '_blank';
            directionsLink.rel = 'noopener noreferrer';
            directionsLink.textContent = this.directionsLabel;
            links.appendChild(directionsLink);
          }

          if (detailsUrl) {
            if (links.childElementCount) {
              const separator = document.createElement('span');
              separator.className = 'store-locator-info-window__separator';
              separator.textContent = '•';
              links.appendChild(separator);
            }

            const detailsLink = document.createElement('a');
            detailsLink.className = 'store-locator-info-window__link';
            detailsLink.href = detailsUrl;
            detailsLink.textContent = this.detailsLabel;
            links.appendChild(detailsLink);
          }

          if (links.childElementCount) {
            wrapper.appendChild(links);
          }

          this.infoWindow.setContent(wrapper);
          this.infoWindow.open({ map: this.map, anchor: marker });
        }

        createInfoIcon(type) {
          const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          icon.setAttribute('class', 'store-locator-info-window__icon');
          icon.setAttribute('viewBox', '0 0 24 24');
          icon.setAttribute('aria-hidden', 'true');
          icon.setAttribute('focusable', 'false');

          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('fill', 'currentColor');

          if (type === 'phone') {
            path.setAttribute(
              'd',
              'M6.6 10.8c1.4 2.8 3.8 5.1 6.6 6.6l2.2-2.2c.3-.3.7-.4 1.1-.3 1.2.4 2.4.6 3.7.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.8 21 3 13.2 3 3.8c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.7.1.4 0 .8-.3 1.1l-2.2 2.2Z'
            );
          } else {
            path.setAttribute(
              'd',
              'M12 2C8.1 2 5 5.1 5 9c0 5.2 7 13 7 13s7-7.8 7-13c0-3.9-3.1-7-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5Z'
            );
          }

          icon.appendChild(path);
          return icon;
        }

        fitMapToVisibleStores() {
          if (!this.map || !window.google || !window.google.maps) return;

          const visibleMarkers = this.markers.filter((marker) => marker && marker.getVisible());

          if (visibleMarkers.length > 1) {
            const bounds = new google.maps.LatLngBounds();
            visibleMarkers.forEach((marker) => {
              const position = marker.getPosition();
              if (position) {
                bounds.extend(position);
              }
            });
            this.map.fitBounds(bounds, 64);
          } else if (visibleMarkers.length === 1) {
            const position = visibleMarkers[0].getPosition();
            if (position) {
              this.map.panTo(position);
              this.map.setZoom(Math.max(this.initialZoom, 13));
            }
          }
        }

        loadMap() {
          if (window.google && window.google.maps && window.markerClusterer) {
            this.initMap();
            return;
          }

          if (!window.__storeLocatorGoogleMapsPromise) {
            window.__storeLocatorGoogleMapsPromise = new Promise((resolve, reject) => {
              const existingScript = document.getElementById('StoreLocatorGoogleMapsScript');
              if (existingScript) {
                existingScript.addEventListener('load', resolve, { once: true });
                existingScript.addEventListener(
                  'error',
                  () => {
                    window.__storeLocatorGoogleMapsPromise = null;
                    reject(new Error('Google Maps failed to load'));
                  },
                  { once: true }
                );
                return;
              }

              let loadedCount = 0;
              const loadComplete = () => {
                loadedCount++;
                if (loadedCount === 2) resolve();
              };

              window.__storeLocatorGoogleMapsInit = loadComplete;

              const script = document.createElement('script');
              script.id = 'StoreLocatorGoogleMapsScript';
              script.async = true;
              script.defer = true;
              script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(
                this.apiKey
              )}&callback=__storeLocatorGoogleMapsInit`;
              script.onerror = () => {
                window.__storeLocatorGoogleMapsPromise = null;
                reject(new Error('Google Maps failed to load'));
              };
              document.head.appendChild(script);

              const markerClustererScript = document.createElement('script');
              markerClustererScript.src =
                'https://cdn.jsdelivr.net/npm/@googlemaps/markerclusterer@2.0.0/dist/index.min.js';
              markerClustererScript.async = true;
              markerClustererScript.onerror = () => {
                window.__storeLocatorGoogleMapsPromise = null;
                reject(new Error('MarkerClusterer failed to load'));
              };
              markerClustererScript.onload = loadComplete;
              document.head.appendChild(markerClustererScript);
            });
          }

          window.__storeLocatorGoogleMapsPromise
            .then(() => {
              this.initMap();
            })
            .catch(() => {
              if (this.mapElement) {
                const fallback = document.createElement('div');
                fallback.className = 'store-locator__map-fallback';
                fallback.textContent = this.mapFallback;
                this.mapElement.replaceChildren(fallback);
              }
            });
        }

        initMap() {
          if (this.ready || !this.mapElement || !window.google || !window.google.maps) return;
          this.ready = true;

          const validStores = this.items
            .map((item, index) => {
              const latitude = parseFloat(item.dataset.latitude || '');
              const longitude = parseFloat(item.dataset.longitude || '');

              if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
                return null;
              }

              return {
                index,
                item,
                position: { lat: latitude, lng: longitude },
              };
            })
            .filter(Boolean);

          const fallbackCenter = {
            lat: Number.isFinite(this.defaultLatitude) ? this.defaultLatitude : 48.8566,
            lng: Number.isFinite(this.defaultLongitude) ? this.defaultLongitude : 2.3522,
          };

          this.map = new google.maps.Map(this.mapElement, {
            center: fallbackCenter,
            zoom: this.initialZoom,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            zoomControl: true,
            clickableIcons: false,
            gestureHandling: 'greedy',
            styles: [
              { elementType: 'geometry', stylers: [{ color: '#efe7d8' }] },
              { elementType: 'labels.text.fill', stylers: [{ color: '#8a7864' }] },
              { elementType: 'labels.text.stroke', stylers: [{ color: '#faf8f6' }] },
              { featureType: 'administrative', elementType: 'geometry.stroke', stylers: [{ color: '#d8c9ad' }] },
              { featureType: 'landscape.natural', elementType: 'geometry', stylers: [{ color: '#e8dcc5' }] },
              { featureType: 'poi', stylers: [{ visibility: 'off' }] },
              { featureType: 'poi.park', elementType: 'geometry', stylers: [{ color: '#dcd0b4' }] },
              { featureType: 'road', elementType: 'geometry', stylers: [{ color: '#faf8f6' }] },
              { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ color: '#e3d8c4' }] },
              { featureType: 'road.arterial', elementType: 'geometry', stylers: [{ color: '#fbf9f5' }] },
              { featureType: 'road.highway', elementType: 'geometry', stylers: [{ color: '#f0e6d2' }] },
              { featureType: 'transit', stylers: [{ visibility: 'off' }] },
              { featureType: 'water', elementType: 'geometry', stylers: [{ color: '#cdbf9f' }] },
              { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#a8967a' }] },
            ],
          });

          this.infoWindow = new google.maps.InfoWindow({
            disableAutoPan: true,
          });

          const createClassicIcon = (color) => {
            const svg = `
              <svg xmlns="http://www.w3.org/2000/svg" width="38" height="50" viewBox="0 0 38 50">
                <path d="M19 0C8.5 0 0 8.5 0 19c0 12.4 19 31 19 31s19-18.6 19-31C38 8.5 29.5 0 19 0Z" fill="${color}"/>
                <circle cx="19" cy="19" r="7.5" fill="#fff"/>
                <circle cx="19" cy="19" r="3.5" fill="${color}"/>
              </svg>
            `;

            return {
              url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
              scaledSize: new google.maps.Size(38, 50),
              anchor: new google.maps.Point(19, 50),
            };
          };

          const createCircleWithBread = (color) => {
            const svg = `
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                <circle cx="24" cy="24" r="24" fill="${color}"/>
                <g transform="rotate(-18 24 24)">
                  <ellipse cx="24" cy="24" rx="13" ry="7.5" fill="#fff"/>
                  <path d="M18 20.8l1.8 5.6M23.3 20l1.8 6M28.6 20.8l1.8 5.6" fill="none" stroke="${color}" stroke-width="1.7" stroke-linecap="round"/>
                </g>
              </svg>
            `;

            return {
              url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
              scaledSize: new google.maps.Size(48, 48),
              anchor: new google.maps.Point(24, 24),
            };
          };

          const createCircleWithCroissant = (color) => {
            const svg = `
              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48">
                <circle cx="24" cy="24" r="24" fill="${color}"/>
                <g fill="#fff">
                  <ellipse cx="24" cy="23" rx="6.2" ry="7.5"/>
                  <ellipse cx="15.5" cy="25.5" rx="5.2" ry="4.2" transform="rotate(-32 15.5 25.5)"/>
                  <ellipse cx="32.5" cy="25.5" rx="5.2" ry="4.2" transform="rotate(32 32.5 25.5)"/>
                  <circle cx="10.8" cy="29.5" r="2.1"/>
                  <circle cx="37.2" cy="29.5" r="2.1"/>
                </g>
                <path d="M19 17.5 17.5 27.5M29 17.5l1.5 10" fill="none" stroke="${color}" stroke-width="1.4" stroke-linecap="round"/>
              </svg>
            `;

            return {
              url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
              scaledSize: new google.maps.Size(48, 48),
              anchor: new google.maps.Point(24, 24),
            };
          };

          let markerIcon;
          switch (this.markerIconType) {
            case 'bread':
              markerIcon = createCircleWithBread(this.accentColor || '#8a5a2b');
              break;
            case 'croissant':
              markerIcon = createCircleWithCroissant(this.accentColor || '#8a5a2b');
              break;
            case 'classic':
            default:
              markerIcon = createClassicIcon(this.accentColor || '#d8232a');
              break;
          }

          const accentColor = this.accentColor || '#d8232a';

          const createClusterBubbleIcon = (count) => {
            const svg = window.btoa(`
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56">
                <circle cx="28" cy="28" r="28" fill="${accentColor}"/>
                <text x="28" y="34" text-anchor="middle" font-size="18" font-weight="600" fill="white" font-family="Arial">${count}</text>
              </svg>
            `);

            return {
              url: `data:image/svg+xml;base64,${svg}`,
              scaledSize: new google.maps.Size(56, 56),
              anchor: new google.maps.Point(28, 28),
            };
          };

          if (this.enableClustering) {
            this.clusterer = new markerClusterer.MarkerClusterer({
              map: this.map,
              markers: [],
              renderer: {
                render: (cluster) =>
                  new google.maps.Marker({
                    position: cluster.position,
                    icon: createClusterBubbleIcon(cluster.count),
                    title: `${cluster.count} ${this.countLabelPlural}`,
                  }),
              },
            });

            // The clusterer only calls renderer.render() for groups of 2+ markers; a
            // marker left alone at the current zoom keeps its regular pin icon. When
            // we're in a "grouped" view (at least one real cluster on screen), show
            // lone markers with the same numbered-bubble style (count of 1) instead,
            // so every marker reads consistently as part of the grouped view.
            google.maps.event.addListener(this.clusterer, 'clusteringend', (clusterer) => {
              const clusters = clusterer.clusters || [];
              const hasGroupedClusters = clusters.some((cluster) => cluster.markers && cluster.markers.length > 1);

              clusters.forEach((cluster) => {
                if (!cluster.markers || cluster.markers.length !== 1) return;
                const marker = cluster.markers[0];
                marker.setIcon(hasGroupedClusters ? createClusterBubbleIcon(1) : markerIcon);
              });
            });
          }

          this.markers = this.items.map((item) => {
            const latitude = parseFloat(item.dataset.latitude || '');
            const longitude = parseFloat(item.dataset.longitude || '');

            if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
              return null;
            }

            const marker = new google.maps.Marker({
              position: { lat: latitude, lng: longitude },
              icon: markerIcon,
              title: item.dataset.name || '',
              map: this.clusterer ? null : this.map,
            });

            marker.addListener('click', () => {
              const index = Number(item.dataset.index || '0');
              this.activateStore(index, true);
            });

            if (this.clusterer) {
              this.clusterer.addMarker(marker);
            }
            return marker;
          });

          if (validStores.length > 1) {
            const bounds = new google.maps.LatLngBounds();
            validStores.forEach((store) => bounds.extend(store.position));
            this.map.fitBounds(bounds, 64);
            google.maps.event.addListenerOnce(this.map, 'idle', () => {
              if (this.map.getZoom() > this.initialZoom + 2) {
                this.map.setZoom(this.initialZoom + 2);
              }
              if (window.matchMedia('(max-width: 749px)').matches) {
                this.map.setZoom(this.map.getZoom() - 0.5);
              }
            });
          } else if (validStores.length === 1) {
            this.map.setCenter(validStores[0].position);
            this.map.setZoom(this.initialZoom);
          } else {
            this.map.setCenter(fallbackCenter);
            this.map.setZoom(this.initialZoom);
          }

          this.applyFilter(this.activeFilter, false);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
